import React, {useContext, useEffect, useState} from 'react';
import {Bars} from 'react-loader-spinner'
import {authContext} from '../Context/Authentication/authContext';
import {styled} from '@mui/material/styles';
import {
  Grid,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Button,
  TextField,
  Autocomplete,
  Slider,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Accordion
} from '@mui/material';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import SendIcon from '@mui/icons-material/Send';
import img from '../assets/MicrosoftTeams-image.png';
import {getMetroGeoLocationData, getMetroZipcode, getQuarterFromDate} from '../Helpers/helpers';

import {LAGS_WHAT_IF_MULTI, whatIfMultiAPICall, getMultiAnalysisData} from './helper'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Chart from './Chart/Chart';
import MultiChart from './Chart/MultiChart';
import CompareChart from './Chart/CompareChart';
import MapPopup from './Map/MapPopup';
import LoadingText from './LoadingText';
import './WhatIfAnalysis.scss'

const marks = [
  {value: 0, label: '0%'},
  {value: 2.5},
  {value: 5},
  {value: 7.5},
  {value: 10},
  {value: 12.5, label: '12.5%'},
  {value: 15},
  {value: 17.5},
  {value: 20},
  {value: 22.5},
  {value: 25, label: '25%'},
];




const PrettoSlider = styled(Slider)({
  color: '#fff',
  height: 4,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    // height: 24,
    // width: 24,
    backgroundColor: '#f7b047',
    border: '2px solid #f7b047',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    fontWeight: 600,
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    background: 'linear-gradient(#fab144 -49.88%, rgba(255, 168, 13, 0.1) 102.13%)',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': {display: 'none'},
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
  '& .MuiSlider-markLabel': {
    color: '#f7b047',
  },
});

const WhatIfMulti = (props: any) => {
  const {isMSA} = props
  const {state}: any = useContext(authContext);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState({
    name: '',
    symbol: ''
  });
  const [lag, setLag] = useState(LAGS_WHAT_IF_MULTI[1].value);
  const [submittedLag, setSubmittedLag] = useState(LAGS_WHAT_IF_MULTI[1].value);
  const [mRate, setMRate]: any = useState(0);
  const [uRate, setURate]: any = useState(0);
  const [pRate, setPRate]: any = useState(0);
  const [submittedMRate, setSubmittedMRate] = useState(5);
  const [submittedURate, setSubmittedURate] = useState(5);
  const [submittedPRate, setSubmittedPRate] = useState(5);
  const [submittedCity, setSubmittedCity] = useState('');
  const [ppsf, setPpsf] = useState(0);
  const [hs, setHs] = useState(0);
  const [dom, setDom] = useState(0);
  const [mortgageRate, setMortgageRate] = useState('No Data');
  const [unemploymentRate, setUnemploymentRate] = useState('No Data');
  const [populationRate, setPopulationRate] = useState('No Data');
  const [populationGrowthRate, setPopulationGrowthRate] = useState('No Data');
  const [predictionDate, setPredictionDate] = useState('2024-Q1');
  const [isLoading, setLoading] = useState(false);
  const [isDataChanged, setDataChanged] = useState(false);
  const [chartAvailable, setChartAvailable] = useState(false);
  const [isError, setIsError] = useState(false);
  const [PPSFData, setPPSFfData] = useState([]);
  const [HSData, setHSData] = useState([]);
  const [DOMData, setDOMData] = useState([]);
  const [PPSFTrendData, setPPSFTrendData] = useState([]);
  const [HSTrendData, setHSTrendData] = useState([]);
  const [DOMTrendData, setDOMTrendData] = useState([]);
  const [PPSFPopulationCompareData, setPPSFPopulationCompareData] = useState([]);
  const [PPSFMortgageCompareData, setPPSFMortgageCompareData] = useState([]);
  const [PPSFUnemploymentCompareData, setPPSFUnemploymentCompareData] = useState([]);
  const [HSPopulationCompareData, setHSPopulationCompareData] = useState([]);
  const [HSMortgageCompareData, setHSMortgageCompareData] = useState([]);
  const [HSUnemploymentCompareData, setHSUnemploymentCompareData] = useState([]);
  const [DOMPopulationCompareData, setDOMPopulationCompareData] = useState([]);
  const [DOMMortgageCompareData, setDOMMortgageCompareData] = useState([]);
  const [DOMUnemploymentCompareData, setDOMUnemploymentCompareData] = useState([]);
  const [metroGeoJson, setMetroGeoJson]: any = useState([]);
  const [openMap, setOpenMap] = useState(false);
  const [isMapLoading, setIsMapLoading] = useState(true);
  const [isMetricsLoading, setIsMetricsLoading] = useState(true);

  useEffect(() => {
    const citiesInfo = isMSA ? state?.filters?.msaInfo : state?.filters?.citiesInfo
    setCities(citiesInfo)
    setDataChanged(false)
    const selectedState = state?.filters?.state
    if (Object.keys(state?.filters?.predictionTill).length) {
      const predictionQuarter = getQuarterFromDate(state?.filters?.predictionTill[selectedState.toLowerCase()].city)
      console.log(predictionQuarter)
      setPredictionDate(predictionQuarter)
    }
    setCity(citiesInfo[0])
    if (isMSA) getMetroPopUpData(citiesInfo[0])
    getMortgageRateValue(citiesInfo[0].name, isMSA)
  }, [state?.filters?.state, isMSA ? state?.filters?.msaInfo : state?.filters?.citiesInfo,state.filters?.selectedType])

  const getMetroPopUpData = async (msa: any) => {
    setIsMapLoading(true)
    if (msa && msa?.name) {
      const metroZipcodes = await getMetroZipcode(state.filters.state, msa.name);
      const metroData = await getMetroGeoLocationData(metroZipcodes);
      setMetroGeoJson(metroData);
    }
    setIsMapLoading(false)
  }

  const getMortgageRateValue = async (cityName: string, isMsaPage: boolean) => {
    setIsMetricsLoading(true)
    const info = await getMultiAnalysisData(state?.filters?.state, cityName, isMsaPage)
    setMortgageRate(info.mortgageRate)
    setUnemploymentRate(info.unemploymentRate)
    setPopulationRate(info.population)
    if (info.population_growth === 'No Data') {
      setPopulationGrowthRate(info.population_growth)
    } else {
      setPopulationGrowthRate(`${info.population_growth}%`)
    }

    try {
      setMRate(Number(info.mortgageRate))
      setURate(Number(info.unemploymentRate))
      if (!isNaN((Number(info.population_growth)))) {
        setPRate(Number(info.population_growth))
      } else {
        setPRate(Number(0))
      }
    } catch (e) {
      console.error(e)
    }
    setIsMetricsLoading(false)
  }


  const handleCityChange = async (event: any, value: any) => {
    if (value) {
      await getMortgageRateValue(value?.name, isMSA)
      if (isMSA) {
        await getMetroPopUpData(value)
      }
      setCity(value)
    }
  };

  const handleLagChange = (event: SelectChangeEvent) => {
    if (event.target.value) {
      setLag(event.target.value as string)
    }
  };

  const handleSubmit = async () => {
    setLoading(true)
    setDataChanged(true)
    if (isMSA) setSubmittedCity(`${city?.name} ${city?.symbol}`)
    else setSubmittedCity(city?.name)
    setSubmittedMRate(mRate)
    setSubmittedURate(uRate)
    setSubmittedPRate(pRate)
    setSubmittedLag(lag)
    let displayError = false;
    setIsError(displayError)
    try {
      // @ts-ignore
      const selectedLag = LAGS_WHAT_IF_MULTI.find((l: any) => l.value === lag)

      const {
        overall,
        isChartAvailable,
        isError,
        PPSFAdjustedData,
        HSAdjustedData,
        DOMAdjustedData,
        PPSFTimelineData,
        HSTimelineData,
        DOMTimelineData,
        PPSFPopulationCompareData,
        PPSFMortgageCompareData,
        PPSFUnemploymentCompareData,
        HSPopulationCompareData,
        HSMortgageCompareData,
        HSUnemploymentCompareData,
        DOMPopulationCompareData,
        DOMMortgageCompareData,
        DOMUnemploymentCompareData,
      } = await whatIfMultiAPICall(state?.filters?.state, mRate, uRate, pRate, city?.name, selectedLag?.key, isMSA)
      setChartAvailable(isChartAvailable)
      displayError = isError
      if (isChartAvailable && !isError) {
        setHs(overall.hs)
        setDom(overall.dom)
        setPpsf(overall.ppsf)
        setPPSFfData(PPSFAdjustedData)
        setHSData(HSAdjustedData)
        setDOMData(DOMAdjustedData)
        setPPSFTrendData(PPSFTimelineData)
        setHSTrendData(HSTimelineData)
        setDOMTrendData(DOMTimelineData)
        setPPSFPopulationCompareData(PPSFPopulationCompareData)
        setPPSFMortgageCompareData(PPSFMortgageCompareData)
        setPPSFUnemploymentCompareData(PPSFUnemploymentCompareData)
        setHSPopulationCompareData(HSPopulationCompareData)
        setHSMortgageCompareData(HSMortgageCompareData)
        setHSUnemploymentCompareData(HSUnemploymentCompareData)
        setDOMPopulationCompareData(DOMPopulationCompareData)
        setDOMMortgageCompareData(DOMMortgageCompareData)
        setDOMUnemploymentCompareData(DOMUnemploymentCompareData)
      }
    } catch (e) {
      console.error(e)
    }

    setLoading(false)
    setIsError(displayError)
  }

  const sliderMChange = (event: Event, newValue: number | number[]) => {
    setMRate(newValue)
  };

  const sliderUChange = (event: Event, newValue: number | number[]) => {
    setURate(newValue)
  };

  const sliderPChange = (event: Event, newValue: number | number[]) => {
    setPRate(newValue)
  };

  const inputSliderChange = (value: any, type: any) => {
    let min = 0
    let max = 25
    if (type === 'pRate') {
      min = -5
      max = 5
    }
    let val = value
    if (value !== '') {
      if (Number(value) < min) {
        val = min
      } else if (Number(value) > max) {
        val = max
      }
    }
    if (type === 'mRate') {
      setMRate(val)
    } else if (type === 'uRate') {
      setURate(val)
    } else {
      setPRate(val)
    }
  }

  const changeSlider = (event: any) => {
    const {name, value} = event.target;
    inputSliderChange(value, name)
  }

  const handleSpanClick = () => {
    setOpenMap(true)
  }

  const getPMarks=()=>{
    console.log(populationGrowthRate)
    const pMarks = [
      {value: parseInt(populationGrowthRate) - 5, label: `${parseInt(populationGrowthRate) - 5}%`},
      {value: parseInt(populationGrowthRate) -4.5},
      {value: parseInt(populationGrowthRate) -4},
      {value: parseInt(populationGrowthRate) -3.5},
      {value: parseInt(populationGrowthRate) -3},
      {value: parseInt(populationGrowthRate) -2.5},
      {value: parseInt(populationGrowthRate) -2},
      {value: parseInt(populationGrowthRate) -1.5},
      {value: parseInt(populationGrowthRate) -1},
      {value: parseInt(populationGrowthRate) -.5},
      {value:  parseInt(populationGrowthRate), label: populationGrowthRate},
      {value: parseInt(populationGrowthRate) + 0.5},
      {value: parseInt(populationGrowthRate)  + 1},
      {value: parseInt(populationGrowthRate) + 2},
      {value: parseInt(populationGrowthRate) + 2.5},
      {value: parseInt(populationGrowthRate)+ 3},
      {value: parseInt(populationGrowthRate)+ 3.5},
      {value: parseInt(populationGrowthRate)+ 4},
      {value: parseInt(populationGrowthRate)+ 4.5},
      {value: parseInt(populationGrowthRate) + 5, label: `${parseInt(populationGrowthRate) + 5}%`},
    ];
    return pMarks
  }

  return (
    <div className='what-if-container'>
      <div className='what-if-container__heading'>
        {state.filters?.state} What If Multi-Criteria {isMSA ? 'MSA' : ''}{' '}
      </div>
      <div className='what-if-container__row'>
        <Box sx={{flexGrow: 1}}>
          <Grid container spacing={6}>
            <Grid item xs={3}>
              <FormControl fullWidth variant='standard'>
                <InputLabel shrink id='demo-simple-select-label'>
                  Select {isMSA ? 'MSA' : 'City'}
                </InputLabel>
                <Autocomplete
                  className='what-if-multi-select'
                  key='what-if-options'
                  id='what-if-metric-tags'
                  onChange={handleCityChange}
                  loading={isLoading}
                  loadingText={'Loading...'}
                  options={cities}
                  value={city || null}
                  getOptionLabel={(option: any) => isMSA ? `${option?.name} ${option?.symbol}` : option?.name || ''}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={isMSA ? 'MSA' : 'City'}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth variant='standard'>
                <InputLabel shrink id='demo-simple-select-label'>
                  Select Lag
                </InputLabel>
                <Select
                  onChange={handleLagChange}
                  value={lag}
                  size='small'
                >
                  {LAGS_WHAT_IF_MULTI.map((data: any) => (
                    <MenuItem key={data.key} value={data.value}>{data.value}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className='mt1'>
            <Grid item xs={12}>
              {isMSA && (
                isMapLoading ? (
                  <LoadingText/>
                ) : (
                  metroGeoJson.length > 0 && city?.name && (
                    <>
                      <span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={handleSpanClick}>Click here to see the geo location of selected MSA or μSA.</span>
                    </>
                  )
                )
              )}
            </Grid>
          </Grid>
          <Grid container className='mt1'>
            <Grid item xs={12}>
              <div>
                <span>Current Metrics:</span>
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <span className='what-if-current-heading'>Mortgage Rate({predictionDate}): </span>
              {isMetricsLoading ? (
                  <LoadingText/>
                ) :
                <span className={'what-if-current-value'}>{mortgageRate}</span>
              }
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <span className='what-if-current-heading'>Unemployment Rate({predictionDate}): </span>
              {isMetricsLoading ? (
                  <LoadingText/>
                ) :
                <span className={'what-if-current-value'}>{unemploymentRate}</span>
              }
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <span
                className='what-if-current-heading'>Population for {isMSA ? `${city.name} ${city.symbol}` : city.name}: </span>
              {isMetricsLoading ? (
                  <LoadingText/>
                ) :
                <span className={'what-if-current-value'}>{populationRate}</span>
              }
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <span
                className='what-if-current-heading'>Population Growth for {isMSA ? `${city.name} ${city.symbol}` : city.name}: </span>
              {isMetricsLoading ? (
                  <LoadingText/>
                ) :
                <span className={'what-if-current-value'}>{populationGrowthRate}</span>
              }
            </Grid>
          </Grid>
          <Grid container className='mt2'>
            <Grid item xs={12}>
              <div>
                <span>What If:</span>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt1'>
            <Grid item xs={3.5} className='grid-row'>
              <FormControl sx={{m: 1}} fullWidth variant='standard'>
                <InputLabel shrink id='demo-simple-select-label' className='input-label'>
                  Mortgage Rate
                </InputLabel>
                <PrettoSlider
                  valueLabelDisplay='on'
                  aria-label='pretto slider'
                  defaultValue={0}
                  value={mRate}
                  marks={marks}
                  step={.1}
                  min={0}
                  max={25}
                  onChange={sliderMChange}
                />
                <TextField
                  id='m-rate'
                  className='slider-input'
                  defaultValue={mRate}
                  value={mRate}
                  size='small'
                  name='mRate'
                  type='text'
                  onChange={changeSlider}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^[0-9]*\.?[0-9]*$',
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={3.5} className='grid-row'>
              <FormControl sx={{m: 1}} fullWidth variant='standard'>
                <InputLabel shrink id='demo-simple-select-label' className='input-label'>
                  Unemployment Rate
                </InputLabel>
                <PrettoSlider
                  valueLabelDisplay='on'
                  aria-label='pretto slider'
                  defaultValue={0}
                  value={uRate}
                  marks={marks}
                  step={.1}
                  min={0}
                  max={25}
                  onChange={sliderUChange}
                />
                <TextField
                  id='u-rate'
                  className='slider-input'
                  defaultValue={uRate}
                  value={uRate}
                  size='small'
                  name='uRate'
                  type='text'
                  onChange={changeSlider}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^[0-9]*\.?[0-9]*$',
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={3.5} className='grid-row'>
              <FormControl sx={{m: 1}} fullWidth variant='standard'>
                <InputLabel shrink id='demo-simple-select-label' className='input-label'>
                  Current Population Growth
                </InputLabel>
                <PrettoSlider
                  valueLabelDisplay='on'
                  aria-label='pretto slider'
                  defaultValue={0}
                  value={pRate}
                  marks={getPMarks()}
                  step={.001}
                  min={parseInt(populationGrowthRate) - 5}
                  max={parseInt(populationGrowthRate) + 5}
                  onChange={sliderPChange}
                />
                <TextField
                  id='p-rate'
                  className='slider-input'
                  defaultValue={pRate}
                  value={pRate}
                  size='small'
                  name='pRate'
                  type='text'
                  onChange={changeSlider}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^-?[0-9]*\.?[0-9]*$',
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt1'>
            <Grid item xs={3.5}/>
            <Grid item xs={3.5}/>
            <Grid item xs={3.5}>
              <FormControl fullWidth variant='standard'>
                <Button
                  className='run-analysis-multi'
                  size='large'
                  endIcon={<SendIcon/>}
                  onClick={handleSubmit}
                  disabled={isMSA ? isMapLoading : isMetricsLoading}
                >
                  Run Analysis
                </Button>
              </FormControl>
            </Grid>

          </Grid>

        </Box>
      </div>
      <>
        {
          isDataChanged ? (
            <>
              {isLoading
                ? <Bars height='400' ariaLabel='bars-loading' wrapperClass='spinner-progress-bar spinner-position'
                        visible={true}/>
                : (
                  isError ? (
                    <>
                      <div className='what-if-container__row'>
                        <Box sx={{flexGrow: 1}}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <div style={{textAlign: 'center', marginTop: '10%'}}>
                                No data available for selected City: {submittedCity}
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='what-if-border'>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <img
                              style={{height: '7.5rem', width: '10.5rem'}}
                              src={img}
                            ></img>
                          </Grid>
                          <Grid item xs={12}>
                            <div className='what-if-container__sub_heading'>
                              <span className='sub_heading_color'>{submittedMRate}%</span> Change in the Mortgage Rate
                              and <span className='sub_heading_color'>{submittedURate}%</span> Change in Unemployment
                              Rate
                              and <span className='sub_heading_color'>{submittedPRate}%</span> Change in Population
                              Growth has
                              the following projected impact
                              after <span className='sub_heading_color'>{submittedLag.toLowerCase()}</span>:
                            </div>
                          </Grid>
                          <Grid item xs={4} className='mt1'>
                            <span
                              className='section-sub-heading'>Price Per Sq. Ft ({submittedLag.toLowerCase().replace(' lag', '')})</span>
                            <br/>
                            <span className='section-heading'>{ppsf}%</span>
                          </Grid>
                          <Grid item xs={4} className='mt1'>
                        <span
                          className='section-sub-heading'>Home Sales ({submittedLag.toLowerCase().replace(' lag', '')})</span>
                            <br/>
                            <span className='section-heading'>{hs}%</span>
                          </Grid>
                          <Grid item xs={4} className='mt1'>
                        <span
                          className='section-sub-heading'>Days On Market ({submittedLag.toLowerCase().replace(' lag', '')})</span>
                            <br/>
                            <span className='section-heading'>{dom}%</span>
                          </Grid>
                        </Grid>
                        {chartAvailable && (
                          <>
                            <div className='what-if-container__row mt1'>
                              <Grid container spacing={{xs: 4, md: 3}}>
                                <Grid item xs={6}>
                                  <div className='accordion-heading'>{submittedCity} Adjusted:</div>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='ppsf-content'
                                      id='ppsf-panel-header'
                                    >
                                      <Typography>PPSF</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Chart
                                        chartData={PPSFData}
                                        chartId={'ppsf-chart'}
                                        title='Adjusted PPSF Projection'
                                        isMulti
                                        isPredition
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='hs-panel-content'
                                      id='hs-panel-header'
                                    >
                                      <Typography>Home Sales</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Chart
                                        chartData={HSData}
                                        chartId={'hs-chart'}
                                        title='Adjusted HS Projection'
                                        isMulti
                                        isPredition
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='dom-panel-content'
                                      id='dom-panel-header'
                                    >
                                      <Typography>Days On Market</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Chart
                                        chartData={DOMData}
                                        chartId={'dom-chart'}
                                        title='Adjusted DOM Projection  '
                                        isMulti
                                        isPredition
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                                <Grid item xs={6}>
                                  <div className='accordion-heading'>{submittedCity} Time Series Component:</div>
                                  <Accordion>
                                    <Accordion>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls='ppsf-treand-content'
                                        id='ppsf-trend-panel-header'
                                      >
                                        <Typography>PPSF</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <MultiChart
                                          chartData={PPSFTrendData}
                                          chartId={'ppsf-chart'}
                                          title={submittedCity}
                                        />
                                      </AccordionDetails>
                                    </Accordion>
                                  </Accordion>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='hs-trend-content'
                                      id='hs-trend-panel-header'
                                    >
                                      <Typography>Home Sales</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <MultiChart
                                        chartData={HSTrendData}
                                        chartId={'hs-chart'}
                                        title={submittedCity}
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='dom-trend-content'
                                      id='dom-trend-panel-header'
                                    >
                                      <Typography>Days On Market</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <MultiChart
                                        chartData={DOMTrendData}
                                        chartId={'dom-chart'}
                                        title={submittedCity}
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            </div>
                            <div className='what-if-container__row mt1'>
                              <Grid container spacing={{xs: 4, md: 3}}>
                                <Grid item xs={12}>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='m-vs-t-content'
                                      id='m-vs-t-header'
                                    >
                                      <Typography>PPSF Residue Percentage Vs Mortgage Rate, Unemployment Rate and
                                        Population Growth Percentage</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='ppsf-vs-mr-compare-content'
                                          id='ppsf-vs-mr-panel-header'
                                        >
                                          <Typography>Monthly PPSF Residue Percentage Vs Monthly Mortgage
                                            Rate</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={PPSFMortgageCompareData}
                                            chartId={'ppsf-mr-compare-chart'}
                                            title='Monthly PPSF Residue Percentage Vs Monthly Mortgage Rate'
                                            indicators={['Monthly Mortgage Rate', 'Monthly PPSF Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='ppsf-vs-un-compare-content'
                                          id='ppsf-vs-un-panel-header'
                                        >
                                          <Typography>Monthly PPSF Residue Percentage vs Monthly Unemployment
                                            Rate</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={PPSFUnemploymentCompareData}
                                            chartId={'ppsf-un-compare-chart'}
                                            title='Monthly PPSF Residue Percentage vs Monthly Unemployment Rate'
                                            indicators={['Monthly Unemployment Rate', 'Monthly PPSF Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='ppsf-vs-population-compare-content'
                                          id='ppsf-vs-population-panel-header'
                                        >
                                          <Typography>Monthly PPSF Residue Percentage Vs Monthly Population Growth
                                            Percentage</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={PPSFPopulationCompareData}
                                            chartId={'ppsf-compare-chart'}
                                            title='Monthly PPSF Residue Percentage Vs Monthly Population Growth Percentage'
                                            indicators={['Monthly Population Growth Percentage', 'Monthly PPSF Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            </div>
                            <div className='what-if-container__row mt1'>
                              <Grid container spacing={{xs: 4, md: 3}}>
                                <Grid item xs={12}>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='u-vs-t-content'
                                      id='u-vs-t-header'
                                    >
                                      <Typography>Home Sales Residue Percentage Vs Mortgage Rate, Unemployment Rate and
                                        Population Growth Percentage</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='hs-vs-mr-compare-content'
                                          id='hs-vs-mr-panel-header'
                                        >
                                          <Typography>Monthly HS Residue Percentage Vs Monthly Mortgage
                                            Rate</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={HSMortgageCompareData}
                                            chartId={'hs-mr-compare-chart'}
                                            title='Monthly HS Residue Percentage Vs Monthly Mortgage Rate'
                                            indicators={['Monthly Mortgage Rate', 'Monthly HS Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='hs-vs-un-compare-content'
                                          id='hs-vs-un-panel-header'
                                        >
                                          <Typography>Monthly HS Residue Percentage Vs Monthly Unemployment
                                            Rate</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={HSUnemploymentCompareData}
                                            chartId={'hs-un-compare-chart'}
                                            title='Monthly HS Residue Percentage Vs Monthly Unemployment Rate'
                                            indicators={['Monthly Unemployment Rate', 'Monthly HS Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='hs-vs-population-compare-content'
                                          id='hs-vs-population-panel-header'
                                        >
                                          <Typography>Monthly HS Residue Percentage Vs Monthly Population Growth
                                            Percentage </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={HSPopulationCompareData}
                                            chartId={'hs-compare-chart'}
                                            title='Monthly HS Residue Percentage Vs Monthly Population Growth Percentage'
                                            indicators={['Monthly Population Growth Percentage', 'Monthly HS Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            </div>
                            <div className='what-if-container__row mt1'>
                              <Grid container spacing={{xs: 4, md: 3}}>
                                <Grid item xs={12}>
                                  <Accordion>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon/>}
                                      aria-controls='p-vs-t-content'
                                      id='p-vs-t-header'
                                    >
                                      <Typography>Days on Market Residue Percentage Vs Mortgage Rate, Unemployment Rate
                                        and Population Growth Percentage</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='dom-vs-mr-compare-content'
                                          id='dom-vs-mr-panel-header'
                                        >
                                          <Typography>Monthly DOM Residue Percentage Vs Monthly Mortgage
                                            Rate </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={DOMMortgageCompareData}
                                            chartId={'dom-mr-compare-chart'}
                                            title='Monthly DOM Residue Percentage Vs Monthly Mortgage Rate'
                                            indicators={[`Monthly Mortgage Rate`, 'Monthly DOM Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='dom-vs-un-compare-content'
                                          id='dom-vs-un-panel-header'
                                        >
                                          <Typography>Monthly DOM Residue Percentage Vs Monthly Unemployment
                                            Rate</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={DOMUnemploymentCompareData}
                                            chartId={'dom-un-compare-chart'}
                                            title='Monthly DOM Residue Percentage Vs Monthly Unemployment Rate'
                                            indicators={['Monthly Unemployment Rate', 'Monthly DOM Residue Percentage']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon/>}
                                          aria-controls='dom-vs-population-compare-content'
                                          id='dom-vs-population-panel-header'
                                        >
                                          <Typography>Days On Market Sales Residual Monthly Growth vs Population Monthly
                                            Growth</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <CompareChart
                                            chartData={DOMPopulationCompareData}
                                            chartId={'dom-compare-chart'}
                                            title='Days On Market Sales Residual Monthly Growth vs Population Monthly Growth'
                                            indicators={[`Population Growth Monthly`, 'Days On Market Monthly Growth']}
                                          />
                                        </AccordionDetails>
                                      </Accordion>
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )
                )}
            </>
          ) : (
            <>
              <div className='what-if-container__row'>
                <Box sx={{flexGrow: 1}}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <div className='no-data' style={{marginTop: '10%'}}>
                        Please select a scenario and hit 'Run Analysis' to see the analysis.
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </>
          )
        }
        <MapPopup open={openMap} close={() => setOpenMap(false)} geoData={metroGeoJson}
                  msa={`${city?.name} ${city?.symbol}`}/>
      </>
    </div>

  )
}

export default WhatIfMulti;